import { IOption } from './http-function-token';

export class HttpToken {
  static config: IOption = {
    code: 'code',
    codeValue: '1000000',
    message: 'message',
    data: 'data',
    header: 'application/json',
  };
}